/*
 * The password a form asks for itself, when the write it is about to make needs a fresh password
 * tier (security.md §4.5). It is the *last field of that form* and never a dialog: a person filling
 * in a new account should not have a second window open over the one they are typing in, and a
 * dialog that appears after the submit throws away the sentence they were writing (D-10 D11).
 *
 * `StepUpHost`'s dialog stays for the callers that have no form — a menu row, a table's action.
 */

import { t } from "../../i18n/index.ts"
import { PasswordInput } from "../components/PasswordInput.tsx"

export function StepUpPasswordField({
	value,
	onChange,
	error,
}: {
	value: string
	onChange: (value: string) => void
	/** The form was sent without a password. The sentence belongs to the field, so the box carries
	 *  `aria-invalid` and names the line that explains it. */
	error?: string
}) {
	return (
		<PasswordInput
			label={t("auth.stepup.field")}
			hint={t("auth.stepup.fieldHint")}
			value={value}
			onChange={onChange}
			autoComplete="current-password"
			{...(error === undefined ? {} : { error })}
		/>
	)
}
